import { createContext } from "react"

interface PostmateContext {
  emit: (event: string, payload: { [key: string]: unknown }) => void
}

export default createContext<PostmateContext>({
  emit: () => {},
})
